var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.85674 9.86228L12.853 3.8494C13.0493 3.65239 13.049 3.33344 12.852 3.13676C12.655 2.94024 12.3358 2.94075 12.1393 3.13778L6.49998 8.79275L0.860641 3.13757C0.664118 2.94057 0.345187 2.94006 0.148157 3.13656C0.0493879 3.23515 2.84464e-06 3.36431 2.83899e-06 3.49347C2.83336e-06 3.6223 0.049057 3.75096 0.14714 3.84937L6.14324 9.86228C6.23764 9.95716 6.36612 10.0104 6.49998 10.0104C6.63384 10.0104 6.76216 9.95701 6.85674 9.86228Z",
    fill: "#272D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(13) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShevronDown);
export default __webpack_public_path__ + "static/media/shevron-down.eb42fb24d82161bc66836d5f22db5687.svg";
export { ForwardRef as ReactComponent };